// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signInWithCustomToken } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDg8ELaIN6Erm_ebyyrkTAdVxp2xZ2LwKU",
  authDomain: "stinte-portal-dev.firebaseapp.com",
  projectId: "stinte-portal-dev",
  storageBucket: "stinte-portal-dev.firebasestorage.app",
  messagingSenderId: "927101447506",
  appId: "1:927101447506:web:8a9e5d189145ac06d65e8b"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Phi Version

// const firebaseConfig = {
//   apiKey: "AIzaSyCvSK-IUHXso5s6qgnQXZTr17qS0NiLVHc",
//   authDomain: "portal-7d1e9.firebaseapp.com",
//   projectId: "portal-7d1e9",
//   storageBucket: "portal-7d1e9.firebasestorage.app", // ✅ Correct bucket
//   messagingSenderId: "476178266373",
//   appId: "1:476178266373:web:dc6776df518b53aeea1f6c",
//   measurementId: "G-1ZCEL3KRK6",
// // };


// const app = initializeApp(firebaseConfig);



const auth = getAuth(app);
const provider = new GoogleAuthProvider();

// ⚠️ No extra Google scope is requested here, and no access token is saved —
// the app has no Google Calendar integration (it uses its own FullCalendar
// page) and nothing ever reads one. Requesting one and saving the resulting
// token to `localStorage` (found in a repo audit, Oct 2026) meant every
// sign-in left a live, unused, never-expired OAuth credential sitting in
// permanent browser storage — readable by any future XSS or by anyone with
// later access to the same browser profile, for no product benefit.
const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, provider);
    return result.user;
  } catch (error) {
    console.error("Google sign-in error:", error);
    return null;
  }
};

// No Firebase Storage: every file goes through the backend to Supabase
// Storage. getStorage() was here unused and cost ~77 KB of the main bundle.
// Partner company sign-in: the backend checks the password and returns a
// custom token carrying the typed tech name (services/partner_auth_service.py).
const signInWithPartnerToken = (token) => signInWithCustomToken(auth, token);

export { auth, provider, signInWithGoogle, signInWithPartnerToken };
